import { useFormik } from 'formik';
import * as yup from 'yup';

const validationSchema = yup.object().shape({
  feeling: yup.string().required('Mời chọn bước 1'),
  detail: yup
    .string()
    .required('Vui lòng nhập nội dung góp ý vào')
    .min(10, 'Nội dung góp ý ít nhất 10 ký tự'),
});
const initialValues = {
  feeling: 'like',
  detail: '',
};

const useFeedbackForm = ({ handleSubmit }) => {
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  return {
    formik,
  };
};

export default useFeedbackForm;
